import React, { FunctionComponent } from "react";
import { useStyles } from "./styles";
interface Props {
  title: string;
  value: string;
  isDate?:boolean;
}

export const ItemGroup: FunctionComponent<Props> = ({ title, value,isDate = false }) => {
  const styles = useStyles();
  return (
    <div className={styles.itemInfo}>
      <span className={styles.itemInfoKey}>{title}: </span>
      <span className={isDate?styles.itemInfoDateValue:styles.itemInfoValue}>{value} </span>
    </div>
  );
};
